<template>
  <div class="club-page anniversary-logo">
    <section>
      <p class="title">창단30주년 기념로고 의미</p>
      <pre>Together 2024

전남드래곤즈는 전라남도를 연고지로 지역과 상생하고 도민의 자부심이 되기 위해끝없이 나아가고 있습니다.

창단30주년을 맞아 전남은 원년 타이포그래픽과 팀컬러를 활용하여 연고지의 모습들을 녹여냈습 니다. 전남의 랜드마크인 광양제철소와 이순신대교의 야경을 시작으로여수의 돌산대교, 케이블카 그리고 순천만 S자 물길을 거쳐 고흥 나로호 우주센터 그리고 해남 땅끝 전망대를 지나신안의 천사대교와 목포대교까지 이릅니다.

이는 도민의 화합과 연고지에 대한 의미를 되새기고자 하였으며 고유성을강조하였습니다.

전남드래곤즈를 통해 전남도민이 함께 환호할 수 있는 2024년도를 갈망합니다.</pre>
      <div class="logo-div">
        <img src="@/assets/img/club/dragons30.png" alt="dragons30">
        <div class="download-div">
          <button class="ai-btn" @click="downloadFile('dragons30.ai')">AI 다운로드</button>
          <button class="jpg-btn" @click="downloadFile('dragons30.jpg')">JPG 다운로드</button>
        </div>
      </div>
    </section>

    <section>
      <p class="title">창단30주년 기념로고 구성요소 설명</p>
      <div class="scroll">
        <img src="@/assets/img/club/dragons_info_01.png" alt="">
      </div>
    </section>

    <section>
      <p class="title">창단30주년 기념로고 기준컬러</p>
      <div class="scroll">
        <img src="@/assets/img/club/dragons_info_02.png" alt="">
        <img src="@/assets/img/club/dragons_info_03.png" alt="">
      </div>
    </section>
  </div>
</template>

<script>
import {downloadFile} from '@/lib';

export default {
  name: 'AnniversaryLogo',
  data() {
    return {
      tabList: [],
    }
  },
  mounted () {
  },
  methods: {
    downloadFile
  }
}
</script>
